export const headerMenu = () => {
  const burgerBtn = document.querySelector(".js-burger-open");
  const menu = document.querySelector(".header__menu");
  const headerBurger = document.querySelector(".header__burger");
  const headerFixed = document.querySelector(".header__fixed");
  const headerOutLinks = document.querySelector(".header__outlinks");
  const offerToggles = document.querySelectorAll(".js-offer-toggle");
  const offerLinks = document.querySelectorAll(".js-offer-link");
  const legacyOfferSubmenus = menu ? Array.from(menu.querySelectorAll(".submenu")) : [];
  // const mobileMenuMedia = window.matchMedia("(max-width: 768px)");
  const mobileMenuMedia = window.matchMedia("(max-width: 1024px)");

  const closeLegacyOfferSubmenus = () => {
    legacyOfferSubmenus.forEach((submenu) => {
      const parentItem = submenu.closest(".menu-item");
      const trigger = submenu.previousElementSibling;

      parentItem?.classList.remove("menu-item--submenu-open");
      submenu.hidden = mobileMenuMedia.matches;

      if (trigger instanceof HTMLElement) {
        trigger.setAttribute("aria-expanded", "false");
      }
    });
  };

  const resetLegacyOfferSubmenus = () => {
    legacyOfferSubmenus.forEach((submenu) => {
      const parentItem = submenu.closest(".menu-item");
      const trigger = submenu.previousElementSibling;

      parentItem?.classList.remove("menu-item--submenu-open");
      submenu.hidden = false;

      if (trigger instanceof HTMLElement) {
        trigger.setAttribute("aria-expanded", "false");
      }
    });
  };

  const syncLegacyOfferSubmenus = () => {
    if (mobileMenuMedia.matches) {
      closeLegacyOfferSubmenus();
      return;
    }

    resetLegacyOfferSubmenus();
  };

  const closeOfferDropdowns = () => {
    offerToggles.forEach((toggleBtn) => {
      const dropdownId = toggleBtn.getAttribute("aria-controls");
      const dropdown = dropdownId ? document.getElementById(dropdownId) : null;

      toggleBtn.classList.remove("header__link--offer-toggle_open");
      toggleBtn.setAttribute("aria-expanded", "false");

      if (dropdown) {
        dropdown.hidden = true;
      }
    });

    closeLegacyOfferSubmenus();
  };

  burgerBtn?.addEventListener("click", () => {
    menu?.classList.toggle("header__menu_open");
    headerBurger?.classList.toggle("header__burger_open");
    headerOutLinks?.classList.toggle("header__outlinks_open");

    if (!menu?.classList.contains("header__menu_open")) {
      closeOfferDropdowns();
    }
  });

  offerToggles.forEach((toggleBtn) => {
    toggleBtn.addEventListener("click", () => {
      const dropdownId = toggleBtn.getAttribute("aria-controls");
      const dropdown = dropdownId ? document.getElementById(dropdownId) : null;

      if (!dropdown) {
        return;
      }

      const isExpanded = toggleBtn.getAttribute("aria-expanded") === "true";

      closeOfferDropdowns();

      if (!isExpanded) {
        toggleBtn.classList.add("header__link--offer-toggle_open");
        toggleBtn.setAttribute("aria-expanded", "true");
        dropdown.hidden = false;
      }
    });
  });

  offerLinks.forEach((offerLink) => {
    offerLink.addEventListener("click", () => {
      closeOfferDropdowns();
      menu?.classList.remove("header__menu_open");
      headerBurger?.classList.remove("header__burger_open");
      headerOutLinks?.classList.remove("header__outlinks_open");
    });
  });

  legacyOfferSubmenus.forEach((submenu) => {
    const trigger = submenu.previousElementSibling;
    if (!(trigger instanceof HTMLElement)) {
      return;
    }

    trigger.setAttribute("aria-expanded", "false");

    trigger.addEventListener("click", (event) => {
      if (!mobileMenuMedia.matches) {
        return;
      }

      event.preventDefault();

      const parentItem = submenu.closest(".menu-item");
      const isOpen = parentItem?.classList.contains("menu-item--submenu-open");

      closeLegacyOfferSubmenus();

      if (!isOpen) {
        parentItem?.classList.add("menu-item--submenu-open");
        trigger.setAttribute("aria-expanded", "true");
        submenu.hidden = false;
      }
    });

    submenu.querySelectorAll("a").forEach((submenuLink) => {
      submenuLink.addEventListener("click", () => {
        closeOfferDropdowns();
        menu?.classList.remove("header__menu_open");
        headerBurger?.classList.remove("header__burger_open");
        headerOutLinks?.classList.remove("header__outlinks_open");
      });
    });
  });

  syncLegacyOfferSubmenus();
  if (typeof mobileMenuMedia.addEventListener === "function") {
    mobileMenuMedia.addEventListener("change", syncLegacyOfferSubmenus);
  } else {
    window.addEventListener("resize", syncLegacyOfferSubmenus);
  }

  window.addEventListener("scroll", () => {
    if (window.pageYOffset > 67) {
      headerFixed?.classList.add("header__fixed_stick");
    } else {
      headerFixed?.classList.remove("header__fixed_stick");
    }
  });
};
